import { Image, Modal, Form } from "react-bootstrap";
import "../../assets/scss/components/templates/modal.scss";
import closeBtn from "../../assets/images/home/closeModal.svg";
import Btn from "./button";

import google from "../../assets/images/home/google-logo-icon.svg";
import dragIcon from "../../assets/images/home/drag-n-drop-icon.svg";
import { useEffect, useRef, useState } from "react";

const SignupModal = (props) => {
  const [selectedPopup, setSelectedPopup] = useState(" ");
  const [dragFileName, setDragFileName] = useState(
    "Drag your resume or click to upload"
  );
  const [isDragging, setIsDragging] = useState(false);
  const [error, setError] = useState(null); // For showing validation errors

  const fileInputRef = useRef(null); // Ref for the hidden file input

  const allowedFileTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  const [verificationCode, setVerificationCode] = useState([
    "",
    "",
    "",
    "",
    "",
  ]);

  const handleInputChange = (index, value) => {
    // Allow only single numeric or alphabetical character
    if (value.length <= 1 && /^[a-zA-Z0-9]*$/.test(value)) {
      const updatedCode = [...verificationCode];
      updatedCode[index] = value;
      setVerificationCode(updatedCode);

      // Automatically move to the next input field if value is valid
      if (value && index < verificationCode.length - 1) {
        document.getElementById(`code-input-${index + 1}`).focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && index > 0 && !verificationCode[index]) {
      // Move to the previous field on Backspace if current field is empty
      document.getElementById(`code-input-${index - 1}`).focus();
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    handleFileUpload(e.dataTransfer.files);
  };

  const handleFileUpload = (files) => {
    if (files.length > 0) {
      const file = files[0];
      if (!allowedFileTypes.includes(file.type)) {
        setError("Only PDF, DOCX, and DOC files are allowed.");
        return;
      }
      setError(null);
      setDragFileName(file.name);
      const reader = new FileReader();
      reader.onload = () => {
        console.log("File uploaded:", file.name);
        props.closemodal();

        // You can further process the file here
      };
      reader.readAsDataURL(file);
    }
  };

  const handleBoxClick = () => {
    fileInputRef.current.click(); // Trigger the click on the hidden file input
  };

  const handleFileInputChange = (e) => {
    handleFileUpload(e.target.files); // Handle file selection from file input
  };

  useEffect(() => {
    if (props.showmodal) {
      setSelectedPopup("signup");
      setDragFileName("Drag your resume or click to upload");
      setError(null); // Reset error on modal open
    }
  }, [props.showmodal]);

  const renderContent = () => {
    if (selectedPopup === "signup") {
      return (
        <div className="signup">
          <div className="text-center d-flex flex-column justify-content-center align-items-center">
            <h3 className="mb-4">
              Create an account
            </h3>
            <Form className="modal-form">
              <Form.Group className="mb-3 input-field">
                <Form.Control type="text" placeholder="Email Address" />
              </Form.Group>
              <Form.Group className="mb-3 input-field">
                <Form.Control type="text" placeholder="Password" />
              </Form.Group>
              <Btn
                text="Continue with Email"
                class="btn-primary continue-with-email"
                handle={() => setSelectedPopup("continue-with-email")}
              />
            </Form>
            <p className="have-account paragraph-small-regular mb-3">
              Already have an account? <a>Login.</a>
            </p>
            <p className="mb-3">OR</p>
            <Btn
              text="Continue with Google"
              imgSrc={google}
              class="btn-outline continue-with-google"
            />
          </div>
        </div>
      );
    }
    if (selectedPopup === "continue-with-email") {
      return (
        <div className="verification-modal">
          <div className="text-center d-flex flex-column justify-content-center align-items-center">
            <h3 className="mb-4">
              Create an account
            </h3>
            <Form className="modal-form">
              <div className="d-flex align-items-center justify-content-between">
                {verificationCode.map((value, index) => (
                  <Form.Group key={index} className="input-field no-spinner">
                    <Form.Control
                      type="text"
                      id={`code-input-${index}`}
                      value={value}
                      onChange={(e) => handleInputChange(index, e.target.value)}
                      onKeyDown={(e) => handleKeyDown(index, e)}
                      inputMode="text" // Use text input mode
                      maxLength={1} // Restrict to one character
                      className="text-center" // Center align the input content
                    />
                  </Form.Group>
                ))}
              </div>
              <Btn
                text="Confirm Verification Code"
                class="btn-primary continue-with-email"
                handle={() => setSelectedPopup("confirm-verification")}
              />
            </Form>
            <p className="resend-code paragraph-small-regular mb-3">
              <a href="#">Resend Code</a>
            </p>
          </div>
        </div>
      );
    }

    if (selectedPopup === "confirm-verification") {
      return (
        <div className="upload-resume-modal">
          <div className="text-center mb-4">
            <h5 className="heading-5 mb-3">Upload Your Base Resume</h5>
            <p className="paragraph-small-regular">
              We use your resume to learn facts about you. This will ensure all AI-generated resumes are factual.
            </p>
          </div>
          <div className="upload-container">
            <div
              className={`drag-upload-section ${isDragging ? "dragging" : ""}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={handleBoxClick} // Trigger file input click
            >
              <Image src={dragIcon} />
              <h5 className="file-name heading-5 mt-3">{dragFileName}</h5>
              <p className="paragraph-smaller-regular mt-2">
                PDF, DOCX, DOC Allowed Only
              </p>
            </div>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileInputChange}
              accept=".pdf,.doc,.docx" // Restrict allowed file types
            />
            {error && <p className="error-text">{error}</p>}
          </div>
        </div>
      );
    }
  };

  return (
    <Modal
      show={props.showmodal}
      onHide={props.closemodal}
      className="custom-modal"
    >
      <div className="d-flex justify-content-end">
        <Image
          src={closeBtn}
          onClick={props.closemodal}
          className="close-btn"
        />
      </div>
      {renderContent()}
    </Modal>
  );
};

export default SignupModal;
